import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import DiscoverTabs from 'modules/discover/web/discoverTabs.component';
import Breadcrumbs from 'modules/navigation/web/breadcrumbs.component';
import {
  ButtonText,
  Badge,
  View,
  LinkFont,
  Header,
  Image,
  Row,
  InlineLink,
} from 'modules/styled';
import { Button } from 'modules/styled/web';
import { layout } from 'app/styles';
import { showModal } from 'modules/navigation/navigation.actions';
import { getNotificationCount } from 'modules/activity/activity.actions';
import MenuIcon from 'modules/ui/web/menuIcon.component';

const ActivityImage = require('public/img/bell.png');

const FixedCircleButton = {
  position: 'fixed',
  bottom: 2,
  right: 2,
  height: 9,
  width: 9,
  minWidth: 0,
  borderRadius: '100%',
};

class TopNav extends Component {
  static propTypes = {
    location: PropTypes.object,
    auth: PropTypes.object,
    history: PropTypes.object,
    actions: PropTypes.object,
    notif: PropTypes.object,
    screenSize: PropTypes.number,
    title: PropTypes.string,
  };

  state = {};

  componentDidMount() {
    this.getNotificationCount();
    window.addEventListener('focus', getNotificationCount);
  }

  componentDidUpdate(prevProps) {
    const wasNotAuthenticated = !prevProps.auth.isAuthenticated;
    const { isAuthenticated } = this.props.auth;
    if (wasNotAuthenticated && isAuthenticated) this.getNotificationCount();
  }

  getNotificationCount = () => {
    const now = new Date();
    const { isAuthenticated } = this.props.auth;
    if (
      this.state.timeSinceNotificationCount &&
      now.getTime() - this.state.timeSinceNotificationCount.getTime() < 30000
    ) {
      return;
    }
    if (isAuthenticated) {
      this.setState({ timeSinceNotificationCount: now });
      this.props.actions.getNotificationCount();
    }
  };

  componentWillUnmount() {
    window.removeEventListener('focus', getNotificationCount);
  }

  toggleLogin = () => {
    const { location, history } = this.props;
    history.push({ search: `?redirect=${location.pathname}` });
    this.props.actions.showModal('login');
  };

  render() {
    const { auth, actions, notif, screenSize, title } = this.props;
    return (
      <View
        webContainerSx={{
          position: 'sticky',
          top: notif.promptType ? layout.BANNER_PROMPT_HEIGHT : 0,
          zIndex: 200,
        }}
        sx={{
          top: [0],
          left: layout.sideNavWidth,
          zIndex: 100,
          position: 'sticky',
        }}
      >
        <View
          sx={{
            justifyContent: 'center',
            px: [2, 4],
            bg: 'white',
            height: layout.headerHeight,
          }}
        >
          <Row
            sx={{
              zIndex: 1,
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <MenuIcon mr={[2, 4]} />
            <View>
              {title ? <Header>{title}</Header> : <DiscoverTabs />}
              <Row sx={{ mb: -1, mt: -0.5 }}>{!title && <Breadcrumbs />}</Row>
            </View>
            <Row
              sx={{
                justifyContent: 'flex-end',

                flex: 1,
                grow: 1,
                alignItems: 'center',
              }}
            >
              {auth.isAuthenticated ? (
                <InlineLink
                  to="/user/activity"
                  sx={{ bottom: -1, opacity: 0.6 }}
                  hoverSx={{ opacity: 1 }}
                >
                  {notif.count ? (
                    <Badge
                      sx={{ top: -1.5 * 8.01 }}
                      color={'red'}
                      textColor={'#ffffff'}
                      number={notif.count}
                    />
                  ) : null}
                  <Image
                    resizeMode={'contain'}
                    sx={{ height: 4, width: 4, top: '3px' }}
                    source={ActivityImage}
                  />
                </InlineLink>
              ) : (
                <div />
              )}

              <Row
                sx={{
                  ml: [0, 2],
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                {screenSize ? null : (
                  <InlineLink
                    onClick={(e) => {
                      e.preventDefault();
                      actions.showModal('onboarding');
                    }}
                    sx={{ alignItems: 'center' }}
                    hu
                    to=""
                  >
                    <LinkFont sx={{ color: 'blue', mr: 2 }}>Get Started</LinkFont>
                  </InlineLink>
                )}
                {auth.isAuthenticated ? (
                  <Button
                    sx={screenSize ? FixedCircleButton : {}}
                    onClick={() => actions.showModal('newpost')}
                    disabled={!auth.user}
                  >
                    <ButtonText>New Post</ButtonText>
                  </Button>
                ) : (
                  <Button
                    sx={screenSize ? FixedCircleButton : {}}
                    onClick={this.toggleLogin}
                    screenSize={screenSize}
                  >
                    <ButtonText>Login</ButtonText>
                  </Button>
                )}
              </Row>
            </Row>
          </Row>
        </View>
      </View>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth,
    notif: state.notif,
    screenSize: state.navigation.screenSize,
  };
}

export default withRouter(
  connect(mapStateToProps, (dispatch) => ({
    actions: bindActionCreators(
      {
        showModal,
        getNotificationCount,
      },
      dispatch
    ),
  }))(TopNav)
);
